import React from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import SettingsPage from "@/pages/Settings";

export default function SettingsModal() {
  const navigate = useNavigate();
  const close = () => { if (window.history.length > 2) navigate(-1); else navigate("/app"); };
  return (
    <div data-testid="settings-modal" onMouseDown={close} className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-3 backdrop-blur-md md:p-6">
      <div onMouseDown={(e) => e.stopPropagation()} className="relative flex h-[90vh] max-h-[90vh] w-full max-w-5xl flex-col overflow-hidden rounded-3xl border border-zinc-800 bg-zinc-950 p-5 shadow-2xl md:p-7">
        <button data-testid="settings-modal-close" onClick={close} className="absolute right-4 top-4 z-10 rounded-full p-2 text-zinc-400 transition-colors hover:bg-zinc-800 hover:text-white" title="Fermer">
          <X className="h-5 w-5" />
        </button>
        <div className="min-h-0 flex-1">
          <SettingsPage />
        </div>
      </div>
    </div>
  );
}
